import * as propertyTypes from "../property_types.js"

export class UiTimeTextbox extends propertyTypes.AppBaseComponentProps {

    private modelForTimeStringMetadata = new propertyTypes.TextProperty("modelForTimeString", "Model for time string");
    public modelForTimeString: string;

    private metadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.metadataAll = baseMetaData.concat([this.modelForTimeStringMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.metadataAll;
    }
}